import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: calc(100vh - 80px);
  padding: 24px;
  background: #f8f9fa;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const Header = styled.div`
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.h1`
  font-size: 20px;
  font-weight: 600;
  color: #212529;
  margin: 0;
`;

export const ContentWrapper = styled.div`
  margin-top: 20px;
  width: 100%;
  overflow-x: auto;
  padding-bottom: 20px;

  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
  }
`;

export const ErrorContainer = styled.div`
  padding: 20px;
  text-align: center;
  color: #dc3545;
`;
